module.exports = __webpack_public_path__ + "img/teacher-days-bg-img.3d278d8a.png";